<template>
  <transition name="slide-fade" mode="out-in">
    <div id="service" v-wechat-title="$route.meta.title">
      <!-- <van-nav-bar title="麻丘镇" fixed="" left-arrow @click-left="onClickLeft" /> -->
      <div class="main">
        <img src="@/assets/index-bg.png" class="bg" />
        <div class="list">
          <van-loading size="20px" v-show="loading">加载中...</van-loading>
          <div
            class="list-item"
            v-for="(item, index) in list"
            :key="index"
            @click="toUrl(item.id, item.name)"
          >
            <img src="@/assets/san2.png" v-if="item.icon == ''" />
            <img :src="item.icon" v-else />
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="btn1" @click="toJu()">一键举报</div>
    </div>
  </transition>
</template>
<script>
import { NavBar, Loading } from "vant";
import { village } from "@/api/apiData";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.getVillage();
  },
  methods: {
    onClickLeft() {
      this.$router.push("/index");
    },
    toUrl(id, n) {
      this.$router.push({
        path: "/news",
        query: { id: id, name: n },
      });
    },
    toJu() {
      this.$router.push({
        path: "/notice",
        query: { type: 1 },
      });
    },
    getVillage() {
      village().then((res) => {
        this.list = res;
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.btn1 {
  width: 50%;
  margin: 0 auto;
  background: #f44336;
  color: white;
  line-height: 2.5rem;
  height: 2.5rem;
  border-radius: 5px;
  margin-bottom: 3rem;
  font-weight: bold;
  margin-top: 2rem;
}
.main .bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
  /* top: 46px; */
}
/* #service{
    height: 100%;
    background: url("../assets/index-bg.png");
    background-size:100% 100% ;
} */
.main {
  padding-top: 5%;
}
.list {
  display: flex;
  flex-wrap: wrap;
  /* height: 20rem;
  overflow: scroll; */
}
.list-item {
  width: 22.5%;
  /* padding: 1rem; */
  margin-left: 2%;
  margin-bottom: 4%;
}
.list-item img {
  width: 90%;
}
.list-item div {
  color: #100f0f;
  font-weight: bold;
  font-size: 0.9rem;
}
</style>


// WEBPACK FOOTER //
// src/page/services.vue